export function formatINR(num, withSymbol = true) {
  const n = Math.round(Number(num) || 0);
  const s = n.toLocaleString("en-IN");
  return withSymbol ? `₹${s}` : s;
}

export function formatNum(num) {
  return (Number(num) || 0).toLocaleString("en-IN");
}

export function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function formatDateShort(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${d} ${months[parseInt(m,10)-1]}`;
}

export function todayStr() {
  const d = new Date();
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60000);
  return local.toISOString().slice(0, 10);
}

export function monthStr(iso) {
  return (iso || todayStr()).slice(0, 7);
}

export function monthLabel(ym) {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  return `${months[parseInt(m,10)-1]} ${y}`;
}

// status badge color by achievement %
export function statusTone(pct) {
  if (pct >= 100) return "green";
  if (pct >= 80) return "orange";
  return "red";
}

export const toneClasses = {
  green: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  orange: "bg-orange-500/15 text-orange-300 border-orange-500/30",
  red: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  blue: "bg-sky-500/15 text-sky-300 border-sky-500/30",
};

export const gradeClasses = {
  A: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  B: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  C: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  D: "bg-rose-500/15 text-rose-300 border-rose-500/30",
};

export function pct(n, d) {
  return d ? Math.round((n / d) * 1000) / 10 : 0;
}

export function presetRange(preset) {
  const t = new Date();
  const fmt = (dt) => {
    const off = dt.getTimezoneOffset();
    return new Date(dt.getTime() - off * 60000).toISOString().slice(0, 10);
  };
  const today = fmt(t);
  const clone = () => new Date(t);
  switch (preset) {
    case "today": return { start: today, end: today };
    case "yesterday": { const d = clone(); d.setDate(d.getDate() - 1); return { start: fmt(d), end: fmt(d) }; }
    case "this_week": { const d = clone(); const day = (d.getDay() + 6) % 7; d.setDate(d.getDate() - day); return { start: fmt(d), end: today }; }
    case "last_7": { const d = clone(); d.setDate(d.getDate() - 6); return { start: fmt(d), end: today }; }
    case "this_month": { const d = new Date(t.getFullYear(), t.getMonth(), 1); return { start: fmt(d), end: today }; }
    case "last_month": {
      const s = new Date(t.getFullYear(), t.getMonth() - 1, 1);
      const e = new Date(t.getFullYear(), t.getMonth(), 0);
      return { start: fmt(s), end: fmt(e) };
    }
    default: return { start: today, end: today };
  }
}
